import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@ui/components';
import { Button, Dialog } from '@ui/components';
import { DialogContent } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { DialogClose } from '@ui/components';
import { FC } from 'react';

export const NotificationsBulkDeleteDialog: FC<{
  onClose: (value: { handleSubmit: boolean }) => void;
  onRemove: () => void;
  isPending: boolean;
  isOpen: boolean;
}> = ({ onClose, isOpen, onRemove, isPending }) => {
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={() => onClose({ handleSubmit: false })} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('NOTIFICATIONS.BULK_DELETE_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('NOTIFICATIONS.BULK_DELETE_DIALOG_DESCRIPTION')}</DialogDescription>
        <DialogFooter className="flex items-center justify-between gap-4">
          <DialogClose asChild>
            <Button variant="tertiary" wide>
              {t('NOTIFICATIONS.BULK_DELETE_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button isLoading={isPending} onClick={onRemove} variant="primary" wide>
            {t('NOTIFICATIONS.BULK_DELETE_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
